import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderRoot";
import { WebsiteBuilderActionType } from "../../websiteBuilderAction";

export interface IResizeSectionActionPayload {
  id: string;
  prevHeight: number;
  nextHeight: number;
}

export interface IResizeSectionAction {
  type: typeof WebsiteBuilderActionType.RESIZE_SECTION;
  payload: IResizeSectionActionPayload;
}

export function getResizeSectionInverseAction(action: IResizeSectionAction): IResizeSectionAction {
  const { id, prevHeight, nextHeight } = action.payload;

  return {
    type: WebsiteBuilderActionType.RESIZE_SECTION,
    payload: {
      id,
      prevHeight: nextHeight,
      nextHeight: prevHeight,
    },
  };
}

export function applyResizeSectionTreeChange(
  tree: IWebsiteBuilderRoot,
  action: IResizeSectionAction,
): IWebsiteBuilderRoot {
  const { id, nextHeight } = action.payload;

  let updatedTree: IWebsiteBuilderRoot = null;

  if (tree.header.id === id) {
    updatedTree = {
      ...tree,
      header: {
        ...tree.header,
        section: {
          ...tree.header.section,
          height: nextHeight,
        },
      },
    };
  } else if (tree.footer.id === id) {
    updatedTree = {
      ...tree,
      footer: {
        ...tree.footer,
        section: {
          ...tree.footer.section,
          height: nextHeight,
        },
      },
    };
  } else {
    updatedTree = {
      ...tree,
      children: tree.children.map(child => {
        if (child.id === id) {
          return {
            ...child,
            section: {
              ...child.section,
              height: nextHeight,
            },
          };
        } else {
          return child;
        }
      }),
    };
  }

  return updatedTree ?? tree;
}
